// ti/:code/alerts_deforestation_deter_last_months/:total_month
import { deforestationDeterLastType } from 'store/typesActions/types';
import { api } from 'services/api';

// pega dados de desmatamento dos ultimos 30 dias
export const getDeforestationDeterLast = (code) => async (dispatch) => {
	dispatch({ type: deforestationDeterLastType.DEFORESTATION_DETER_LAST });
	try {
		const res = await api.get(`/ti/${code}/alerts_deforestation_deter_last_months/1`);
		const { data } = res || {};
		dispatch({
			type: deforestationDeterLastType.DEFORESTATION_DETER_LAST_SUCCESS,
			payload: data
		});
		return data;
	} catch (error) {
		const { response } = error;
		if (response && response.status === 400) {
			const { message } = response.data;
			dispatch({
				type: deforestationDeterLastType.DEFORESTATION_DETER_LAST_ERROR,
				payload: { errors: { message } }
			});
		} else {
			dispatch({
				type: deforestationDeterLastType.DEFORESTATION_DETER_LAST_ERROR,
				payload: {
					errors: { message: 'Erro desconhecido. Tente novamente mais tarde' }
				}
			});
		}
	}
};
